import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const quoteStorageTypesAdapter = getAdapter({ idFieldName: 'value' });

const quoteStorageTypesSlice = createSlice({
  name: 'quoteStorageTypes',
  initialState: quoteStorageTypesAdapter.getInitialState(),
  reducers: {
    setQuoteStorageTypes: (state, { payload: { quoteStorageTypes } }) => {
      quoteStorageTypesAdapter.setAll(state, quoteStorageTypes);
    },
  },
});

const selectors = quoteStorageTypesAdapter.getSelectors(({ quoteStorageTypes }) => quoteStorageTypes);

export const getQuoteStorageTypes = (state) => selectors.selectAll(state);

export const {
  setQuoteStorageTypes,
} = quoteStorageTypesSlice.actions;

export default quoteStorageTypesSlice.reducer;